// Identifiant d'appareil persistant (liaison d'appareil / device binding).
// Généré une seule fois par navigateur et conservé dans localStorage.
const DEVICE_KEY = 'padaid_device_id';

export const getDeviceId = () => {
  try {
    let id = localStorage.getItem(DEVICE_KEY);
    if (!id) {
      id = (window.crypto && window.crypto.randomUUID)
        ? window.crypto.randomUUID()
        : 'dev-' + Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem(DEVICE_KEY, id);
    }
    return id;
  } catch (e) {
    return 'dev-' + Math.random().toString(36).slice(2);
  }
};
